import { useState } from 'react'
import { ScoopButton, ScoopMenu } from '../../../ui'
import { PencilSimpleIcon, TrashIcon, SparkleIcon } from '@phosphor-icons/react'
import { useDispatch } from 'react-redux'
import { deleteKPI } from '../../../../store/actions'
import { useModal, MODALS } from '../../../modals'

export default function KPIEdit({ isMenuOpen, setIsMenuOpen, title, id }) {
    const [anchorEl, setAnchorEl] = useState(null)
    const dispatch = useDispatch()
    const deleteModal = useModal(MODALS.COMMON.DELETE)

    const open = Boolean(anchorEl)

    const handleClick = (event) => {
        setIsMenuOpen(true)
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setIsMenuOpen(false)
        setAnchorEl(null)
    }

    const handleDelete = () => {
        dispatch(deleteKPI(id))
        setIsMenuOpen(false)
        setAnchorEl(null)
    }

    const handleDeleteClick = () => {
        handleClose()
        deleteModal.show({
            title,
            type: 'KPI',
            onDelete: handleDelete,
        })
    }

    const menuItems = [
        {
            label: 'Edit',
            icon: <PencilSimpleIcon size={18} />,
            onClick: handleClose,
        },
        {
            divider: true,
        },
        {
            label: 'Delete',
            icon: <TrashIcon size={18} />,
            onClick: handleDeleteClick,
        },
    ]

    return (
        <div>
            <ScoopButton variant="icon" onClick={handleClick} aria-label="KPI options">
                <SparkleIcon size={24} />
            </ScoopButton>
            <ScoopMenu anchorEl={anchorEl} open={open} onClose={handleClose} items={menuItems} />
        </div>
    )
}
